import { mapTherapyRowToValues, toTherapyFieldPayload } from '../../../../common';
import { THERAPY_FORM_SCHEMA } from './validationSchema';

import type { TherapyFieldName, TherapyFormValues, TherapyPayload } from '../../../../common';
import type { ITreatmentPlanV3TherapyPage } from '../../../../../store/treatmentPlanV3';

export function toTreatmentPlanV3TherapyFieldPayload<K extends TherapyFieldName>(
  name: K,
  values: TherapyFormValues,
): TherapyPayload {
  return toTherapyFieldPayload(name, values, { includeRecordShared: true });
}

export function hasTherapyFormErrors(page: ITreatmentPlanV3TherapyPage) {
  if (page.no_historical_therapy) return false;
  if (page.therapies.length === 0) return true;
  return page.therapies.some(
    (row) => !THERAPY_FORM_SCHEMA.isValidSync(mapTherapyRowToValues(row)),
  );
}
